import {
   getCourseAssignmentIndividualSummariesFromClient,
   GetCourseAssignmentIndividualSummariesOptions,
} from '~/pages/api/courses/manage/people/user-summaries/getCourseAssignmentIndividualSummaries.api';
import { useIncrementalQuery } from '~/pages/_shared';

const KEY = 'course-assignments-individual-summaries';

export function getCourseAssignmentIndividualSummariesKey() {
   return [KEY];
}

export function useCourseAssignmentIndividualSummaries(
   options?: GetCourseAssignmentIndividualSummariesOptions
) {
   return useIncrementalQuery(
      [KEY, options],
      async page => {
         let { individualSummaries: data, hasMore } =
            await getCourseAssignmentIndividualSummariesFromClient({
               ...options,
               page,
            });
         return { page, data, hasMore };
      },
      { firstPage: 0 }
   );
}
